import { render, staticRenderFns } from "./transactionDetails.vue?vue&type=template&id=73a4988a&scoped=true&"
import script from "./transactionDetails.vue?vue&type=script&lang=js&"
export * from "./transactionDetails.vue?vue&type=script&lang=js&"
import style0 from "./transactionDetails.vue?vue&type=style&index=0&id=73a4988a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a4988a",
  null
  
)

export default component.exports